// نافذة نجاح الاشتراك — تظهر **بعد** نجاح الحفظ وتسجيل المبلغ فقط، فلا يوجد
// زر طباعة قبل أن يصير هناك ما يُطبَع.
//
// الطباعة اختيارية: الإغلاق وحده إنهاء سليم للعملية. وزر الطباعة لا يُنادي أي
// مسار كتابة — يطبع ما وصل مع استجابة الحفظ (أو ما قرأه مسار الإيصال عند
// إعادة الطباعة)، فتكرار الطباعة لا يُنشئ اشتراكاً ولا دفعة ثانية.
import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD, formatDate } from '../../../shared/format.js';
import { printReceipt } from '../../../shared/printReceipt.js';
import { SubscriptionReceipt } from './SubscriptionReceipt.jsx';

export function SubscriptionSuccessModal({ open, onClose, receipt, created, title }) {
  if (!open || !receipt) return null;

  const notes = [];
  if (created?.child) notes.push('سُجِّل الطفل في النظام');
  if (created?.guardian) notes.push('سُجِّل ولي الأمر');
  if (created?.card) notes.push(`سُجِّلت البطاقة ${receipt.cardUid || ''}`.trim());
  else if (created?.cardLinked && receipt.cardUid) notes.push(`رُبطت البطاقة ${receipt.cardUid} بالطفل`);
  if (Number(receipt.cardTopupAmount || 0) > 0) {
    notes.push(`عُبِّئ رصيد ابتدائي ${formatIQD(receipt.cardTopupAmount)} في البطاقة`);
  }

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{ background: 'rgba(15,16,18,0.55)' }}>
      <div
        className="bg-white rounded-[14px] shadow-card max-w-[420px] w-full overflow-hidden max-h-[92vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">
            {title || (receipt.type === 'renewal' ? 'تم تجديد الاشتراك' : 'تم تسجيل الاشتراك الشهري')}
          </h3>
          <button type="button" className="text-ink-3 hover:text-ink" onClick={onClose}>
            <Icon name="x" size={16} />
          </button>
        </div>

        <div className="px-4 pt-3">
          <div
            className="rounded-[10px] px-3 py-2 text-[12.5px]"
            style={{ background: '#DCFCE7', border: '1px solid #BBF7D0', color: '#15803D' }}
          >
            <div className="font-bold">
              {receipt.childName} — {receipt.planName} ({formatDate(receipt.startDate)} ← {formatDate(receipt.endDate)})
            </div>
            <div className="mt-0.5">
              استُلم {formatIQD(receipt.totalReceived || receipt.paidAmount || 0)} وسُجّل برقم الإيصال {receipt.receiptNumber || '—'}
            </div>
            {notes.length ? <div className="mt-0.5 text-[11.5px]">{notes.join(' • ')}</div> : null}
          </div>
        </div>

        <div className="p-4 grid place-items-center overflow-y-auto" style={{ background: '#FAF6EE' }}>
          <SubscriptionReceipt data={receipt} />
        </div>

        <div className="card-h border-b-0 border-t flex gap-2">
          <button type="button" className="btn flex-1 justify-center" onClick={onClose}>إغلاق</button>
          <button type="button" className="btn btn-primary flex-1 justify-center" onClick={() => printReceipt()}>
            <Icon name="print" size={14} /> طباعة الإيصال
          </button>
        </div>
      </div>
    </div>
  );
}
